import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import eyeIcon from "../../../assets/icons/eye.svg";
import eyeIconSlash from "../../../assets/icons/eye-slash-grey.svg";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class EditPassword extends Component {
    constructor() {
        super();
        this.state = {
            p_user_password : '',
            loading         : false,
            hidePassword    : false
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleEdit = () => {
        let form = {
            p_user_id: this.props.data.p_user_id,
            p_user_password: this.state.p_user_password,
        }
        this.props.request("edit_user/password", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        p_user_password : ''
                    },() =>this.props.changeState({
                        edit_pw_visible: false,
                        data: [],
                        loading: true,
                    },() => {
                        this.props.loadData()
                    }))
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }

    render() {
        return (
            <Modal size="lg" zIndex={999} isOpen={this.props.data.edit_pw_visible} toggle={() => {
                this.props.changeState({edit_pw_visible: false, p_user_id:''});
            }}>
                <ModalHeader>Edit Password User</ModalHeader>
                <ModalBody>
                   <div className="px-2 pb-4">
                       <Form layout="vertical" hideRequiredMark>
                           <div className="input-group">
                               <label>Password Baru</label>
                               <input
                                   name="p_user_password"
                                   className="form-control col-xl-12 col-md-12"
                                   placeholder="Password User..."
                                   type={this.state.hidePassword ? "text" : "password"}
                                   required=""
                                   value={this.state.p_user_password}
                                   onPointerEnter={(e) => {
                                       this.triggerGuideOnce(e, {
                                           key: "guidePasswordUserBaru",
                                           title: "Password User",
                                           content: "Masukkan password untuk akun user. Gunakan kombinasi yang aman agar akun lebih terlindungi."
                                       });
                                   }}
                                   onChange={(event) => {
                                       const target = event.target;
                                       const value = target.value;
                                       const name = target.name;
                                       this.setState({
                                           [name]: value
                                       });
                                   }}
                               />
                               <div className="input-group-append">
                                   <div className="input-group-text">
                                       <img className="show-hide-button" style={{ width: "16px", height: "16px", backgroundColor: "#E9ECEF" }} src={this.state.hidePassword ? eyeIcon : eyeIconSlash} onClick={() => this.setState({
                                           hidePassword: !this.state.hidePassword
                                       })}  />
                                   </div>
                               </div>
                           </div>
                       </Form>
                   </div>
                </ModalBody>
                <ModalFooter>
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={this.handleEdit} type="primary">
                            Simpan
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(EditPassword)
